import albums from './albums'
import channels from './channels'
import datasets from './datasets'
import templates from './templates'
import windows from './windows'

export default {
  albums,
  channels,
  datasets,
  templates,
  windows
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js